import { render } from "./ShowPrintPenalty.vue?vue&type=template&id=bb80af9a&scoped=true"
import script from "./ShowPrintPenalty.vue?vue&type=script&lang=js"
export * from "./ShowPrintPenalty.vue?vue&type=script&lang=js"

import "./ShowPrintPenalty.vue?vue&type=style&index=0&id=bb80af9a&lang=css"
import "./ShowPrintPenalty.vue?vue&type=style&index=1&id=bb80af9a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\6217025534\\Desktop\\vsts-agent-win-x64-2\\_work\\40\\s\\PASVue\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb80af9a"]])

export default __exports__